<template>
  <Content>
    <section class="app-main">
      <transition name="fade-transform" mode="out-in">
        <router-view :key="key" />
      </transition>
    </section>
  </Content>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    key () {
      return this.$route.path
    }
  }
}
</script>

<style scoped>
  .app-main {
    width: 100%;
    background-color: #F4F4F9;
    box-sizing: border-box;
    position: relative;
  }
</style>
